/* eslint-disable no-multi-spaces */
/* eslint-disable camelcase */
/* eslint key-spacing: ["error", { align: "value" }] */
/**
 * Vuex module for permissions
 */
import { canRead, canWrite, canExec, canShow, canManage } from './helper'

const ACTIVE_CALLS =     'active_calls'
const ANNOUNCE =         'announcements'
const BUDDIES =          'panel_buddies'
const CALLWAIT =         'call_waiting'
const CONTACTS =         'contacts'
const CDRS =             'cdrs'
const CHATS =            'chats'
const CONFIG =           'configs'
const CONFS =            'conferences'
const DND =              'do_not_disturb'
const FOLLOWME =         'follow_me'
const FORWARD =          'forward'
const INTERCOM =         'intercom'
const PERMS =            'permissions'
const PERSONAL_CONF =    'personal_conferences'
const QUEUES =           'queues'
const QUEUE_REPORTS =    'queue_reports'
const QUEUE_RPT_SCHEDS = 'queue_report_schedules'
const VIDEOCONFS =       'video_conferences'
const VMAILS =           'voicemails'
const VMBOXES =          'voicemail_boxes'
const ECID_PROFILES =    'emergency_caller_id_callback_profiles'
const ECID_LOCATIONS =   'emergency_caller_id_dispatchable_locations'
const TOGGLE_DEST =      'toggle_destinations'
const CLEARLY_AW =       'clearly_anywhere_access'
const SOFTPHONE =        'softphone'
const OTP_CONFIG =       'otp_configurations'
const CLICK_TO_DIAL =    'click_to_dial'
const SCREENPOP =        'screenpop'
const PARKINGS =         'parkings'
const USER_PREFERENCES = 'user_preferences'
const DIDS =           'dids'

const actions = {
  initPermissions: {
    root: true,
    handler ({ commit }, { permissions_group, permissions_user }) {
      commit('INIT', [...permissions_group, ...permissions_user])
    }
  }
}

const mutations = {
  INIT (state, data) {
    state.perms.push(...data)
  },

  RESET (state) {
    state.perms.splice(0)
  }
}

const state = {
  perms: []
}

const getters = {
  userPreferencesRead:       state => canRead(state.perms,  USER_PREFERENCES),
  userPreferencesWrite:      state => canWrite(state.perms,  USER_PREFERENCES),
  hasAccess:                 state => canRead(state.perms,  PERMS),
  usersRead:                 state => canRead(state.perms,  BUDDIES),
  usersWrite:                state => canWrite(state.perms, BUDDIES),
  queuesRead:                state => canRead(state.perms,  QUEUES),
  queuesWrite:               state => canWrite(state.perms, QUEUES),
  queueReportsRead:          state => canRead(state.perms,  QUEUE_REPORTS),
  queueReportSchedulesRead:  state => canRead(state.perms,  QUEUE_RPT_SCHEDS),
  queueReportSchedulesWrite: state => canWrite(state.perms, QUEUE_RPT_SCHEDS),
  contactsRead:              state => canRead(state.perms,  CONTACTS),
  contactsWrite:             state => canWrite(state.perms, CONTACTS),
  contactsManagePersonal:    state => canManage(state.perms, CONTACTS, 'personal'),
  chatsRead:                 state => canRead(state.perms,  CHATS),
  chatsWrite:                state => canWrite(state.perms, CHATS),
  conferencesRead:           state => canRead(state.perms,  CONFS),
  conferencesWrite:          state => canWrite(state.perms, CONFS),
  videoConfRead:             state => canRead(state.perms,  VIDEOCONFS),
  videoConfWrite:            state => canWrite(state.perms, VIDEOCONFS),
  personalConfRead:          state => canRead(state.perms,  PERSONAL_CONF),
  personalConfWrite:         state => canWrite(state.perms, PERSONAL_CONF),
  announceRead:              state => canRead(state.perms,  ANNOUNCE),
  announceWriteFor:          state => id => canWrite(state.perms, ANNOUNCE, id),
  announceWrite:             state => canWrite(state.perms, ANNOUNCE),
  vmailsRead:                state => canRead(state.perms,  VMAILS),
  vmailsWrite:               state => canWrite(state.perms, VMAILS),
  vmboxesRead:               state => canRead(state.perms,  VMBOXES),
  vmboxReadFor:              state => id => canRead(state.perms, VMBOXES, id),
  vmboxesWrite:              state => canWrite(state.perms, VMBOXES),
  vmboxWriteFor:             state => id => canWrite(state.perms, VMBOXES, id),
  cdrsRead:                  state => canRead(state.perms,  CDRS),
  cdrsWrite:                 state => canWrite(state.perms, CDRS),
  parkRead:                  state => canRead(state.perms,  PARKINGS),
  parkWrite:                 state => canWrite(state.perms, PARKINGS),
  toggleRead:                state => canRead(state.perms,  TOGGLE_DEST),
  toggleWrite:               state => canWrite(state.perms, TOGGLE_DEST),
  // settings
  dndRead:                   state => canRead(state.perms,  DND),
  dndReadFor:                state => id => canRead(state.perms, DND, id),
  dndWrite:                  state => canWrite(state.perms, DND),
  dndWriteFor:               state => id => canWrite(state.perms, DND, id),
  icomRead:                  state => canRead(state.perms,  INTERCOM),
  icomReadFor:               state => id => canRead(state.perms, INTERCOM, id),
  icomWrite:                 state => canWrite(state.perms, INTERCOM),
  icomWriteFor:              state => id => canWrite(state.perms, INTERCOM, id),
  cwtRead:                   state => canRead(state.perms,  CALLWAIT),
  cwtReadFor:                state => id => canRead(state.perms, CALLWAIT, id),
  cwtWrite:                  state => canWrite(state.perms, CALLWAIT),
  cwtWriteFor:               state => id => canWrite(state.perms, CALLWAIT, id),
  fwdRead:                   state => canRead(state.perms,  FORWARD),
  fwdReadFor:                state => id => canRead(state.perms, FORWARD, id),
  fwdWrite:                  state => canWrite(state.perms, FORWARD),
  fwdWriteFor:               state => id => canWrite(state.perms, FORWARD, id),
  fmeRead:                   state => canRead(state.perms,  FOLLOWME),
  fmeReadFor:                state => id => canRead(state.perms, FOLLOWME, id),
  fmeWrite:                  state => canWrite(state.perms, FOLLOWME),
  fmeWriteFor:               state => id => canWrite(state.perms, FOLLOWME, id),
  confRead:                  state => canRead(state.perms,  CONFIG),
  confWrite:                 state => canWrite(state.perms, CONFIG),
  ecidProfRead:              state => canRead(state.perms,  ECID_PROFILES),
  ecidProfListFor:           state => canRead(state.perms, ECID_PROFILES),
  ecidProfReadFor:           state => id => canRead(state.perms, ECID_PROFILES, id),
  ecidProfWrite:             state => canWrite(state.perms, ECID_PROFILES),
  ecidLocRead:               state => canRead(state.perms,  ECID_LOCATIONS),
  ecidLocReadFor:            state => id => canRead(state.perms, ECID_LOCATIONS, id),
  ecidLocListFor:            state => canRead(state.perms, ECID_LOCATIONS),
  ecidLocWrite:              state => canWrite(state.perms, ECID_LOCATIONS),
  clearlyAWRead:             state => canRead(state.perms,  CLEARLY_AW),
  softphoneRead:             state => canRead(state.perms,  SOFTPHONE),
  otpRead:                   state => canRead(state.perms,  OTP_CONFIG),
  otpReadFor:                state => id => canRead(state.perms, OTP_CONFIG, id),
  otpWrite:                  state => canWrite(state.perms, OTP_CONFIG),
  ctdRead:                   state => canRead(state.perms,  CLICK_TO_DIAL),
  ctdReadFor:                state => id => canRead(state.perms, CLICK_TO_DIAL, id),
  ctdWrite:                  state => canWrite(state.perms, CLICK_TO_DIAL),
  ctdWriteFor:               state => id => canWrite(state.perms, CLICK_TO_DIAL, id),
  didsRead:                  state => canRead(state.perms,  DIDS),
  didsReadFor:               state => id => canRead(state.perms, DIDS, id),
  screenPopRead:             state => canRead(state.perms, SCREENPOP),
  screenPopReadFor:          state => id => canRead(state.perms, SCREENPOP, id),
  screenPopWrite:            state => canWrite(state.perms, SCREENPOP),
  screenPopWriteFor:         state => id => canWrite(state.perms, SCREENPOP, id),
  // exec rights
  conferCanCall:             state => id => canExec(state.perms, CONFS,        'callconference', id),
  conferCanInvite:           state => id => canExec(state.perms, CONFS,        'confinvite', id),
  canChanSpy:                state => id => canExec(state.perms, ACTIVE_CALLS, 'callspy', id),
  canCallRecord:             state => id => canExec(state.perms, ACTIVE_CALLS, 'record', id),
  canQAgentPause:            state => id => canExec(state.perms, QUEUES,       'pause', id),
  canQSelfPause:             state => id => canExec(state.perms, QUEUES,       'pause_self', id),
  canQCallRedirSelf:         state => canExec(state.perms,       QUEUES,       'redirect_self'),
  canQCallRedirUser:         state => canExec(state.perms,       QUEUES,       'redirect_user'),
  // show
  showVMCount:               state => id => canShow(state.perms, BUDDIES, 'voicemail_count', id),
  showCallState:             state => id => canShow(state.perms, BUDDIES, 'call_state', id),
  showBuddyCallers:          state => id => canShow(state.perms, BUDDIES, 'caller_id_info', id),
  showBuddyDND:              state => id => canShow(state.perms, BUDDIES, 'dnd', id),
  showBuddyCFWD:             state => id => canShow(state.perms, BUDDIES, 'callforward', id),
  showBuddyFME:              state => id => canShow(state.perms, BUDDIES, 'followme', id)
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
